module.exports = __webpack_public_path__ + "455fac5375494209217870ca945187e8.svg";